import * as React from 'react';
import { Link } from 'react-router';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';
import styled, { keyframes } from 'styled-components';
import { rem, darken } from 'polished';

export interface Props {
  isFavorite: boolean;
}

function FavoriteCompare({ isFavorite }: Props) {
  const [isHoverFav, setIsHoverFav] = React.useState(false);
  const [isHoverComp, setIsHoverComp] = React.useState(false);

  const onSetIsHoverFav = e => {
    setIsHoverFav(true);
  };
  const offSetIsHoverFav = e => {
    setIsHoverFav(false);
  };

  const onSetIsHoverComp = e => {
    setIsHoverComp(true);
  };
  const offSetIsHoverComp = e => {
    setIsHoverComp(false);
  };

  return (
    <Wrapper>
      <StyledLink
        to={''}
        onMouseEnter={onSetIsHoverComp}
        onMouseLeave={offSetIsHoverComp}
      >
        <SvgIcon
          icon={IconType.compare}
          fill={isHoverComp ? '#000000' : '#DDDDDD'}
        />
      </StyledLink>
      <Link
        to={''}
        onMouseEnter={onSetIsHoverFav}
        onMouseLeave={offSetIsHoverFav}
      >
        <SvgIcon
          icon={IconType.favourites}
          fill={
            isHoverFav
              ? '#000000'
              : isFavorite
              ? 'rgba(255, 30, 69, 0.92)'
              : '#DDDDDD'
          }
        />
      </Link>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  diplay: flex;
  flex-direction: row;
`;

const StyledLink = styled(Link)`
  margin-right: ${rem(8)};
`;

export { FavoriteCompare };
